<ds-modal [modal]="modal" [title]="'move_asset' | translate" [maxWidthPercentage]="80" (modalClosed)="onCancel()">
  <div class="modal-content-wrapper">
    <p>{{ 'required_fields_label' | translate }}</p>

    <ds-input
      [label]="'move_digital_property_title' | translate"
      [instructions]="'move_digital_property_instructions' | translate"
      [required]="true"
    >
      <select
        ds-input-field
        [ngModel]="destinationWorkspaceId()"
        (ngModelChange)="onWorkspaceSelected($event)"
        [disabled]="isLoading"
        [required]="true"
      >
        <option [ngValue]="null" disabled>{{ 'select_workspace' | translate }}</option>

        @for (workspace of availableWorkspaces; track workspace[$workspace._id]) {
          <option [ngValue]="workspace[$workspace._id]">
            {{ workspace[$workspace.name] }}
          </option>
        }
      </select>
    </ds-input>

    @if (hasKeyCollision()) {
      <p class="text-danger mt-2">{{ 'move_asset_key_collision_warning' | translate }}</p>
    }
    @if (hasNameCollision()) {
      <p class="text-danger mt-2">{{ 'move_asset_name_collision_warning' | translate }}</p>
    }

    <div class="d-flex gap-3 mt-4">
      <button ds-button [variant]="DsButtonVariants.primary" (click)="onMoveConfirmed()" [disabled]="isLoading || !canMove()">
        {{ 'move_asset' | translate }}
      </button>

      <button ds-button [variant]="DsButtonVariants.secondary" (click)="onCancel()" [disabled]="isLoading">
        {{ 'label_cancel' | translate }}
      </button>
    </div>
  </div>
</ds-modal>
